<template>
  <section class="mx-auto justify-content-center">
    <div class="top">
      <ChannelSectionTitle>
        {{ $t('DECLINE_CONFIRMED_1') }}
      </ChannelSectionTitle>
      <ChanelCaption class="c-mt-4" small>{{ $t('DECLINE_CONFIRMED_2') }}</ChanelCaption>
      <ChanelCaption small>{{ $t('DECLINE_CONFIRMED_3') }}</ChanelCaption>
    </div>

    <contact-block class="contact-block"></contact-block>
  </section>
</template>

<script>
import ContactBlock from '@/components/ContactBlock.vue'
import ChannelSectionTitle from '@/components/ChannelSectionTitle.vue'
import ChanelCaption from '@/components/ChanelCaption.vue'

export default {
  name: 'Confirmation',
  components: {
    ChannelSectionTitle,
    ContactBlock,
    ChanelCaption
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/style/colors.scss';
@import '@/assets/style/vars.scss';

section {
  text-align: center;
  padding-bottom: $gap-3;

  .top {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 2;
  }
}
</style>
